import { queryOptions } from '@tanstack/react-query';

import { getIntegrationQueryKeys } from '@/entities/(integration)/integrations';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { getHelpscoutInfo } from './get-helpscout-info';
import { getHelpscoutMailboxes } from './get-helpscout-mailboxes';

export const helpscoutQueryKeys = {
  all: (workspaceAlias: string) =>
    getIntegrationQueryKeys(SOURCE_TYPE.HELPSCOUT, workspaceAlias),
  mailboxes: (workspaceAlias: string) => [
    ...helpscoutQueryKeys.all(workspaceAlias),
    'mailboxes',
  ],
};

/**
 * Helpscout 연동 정보 조회 queryOptions
 */
export const helpscoutInfoQueryOptions = (
  workspaceAlias: string,
  options?: { enabled?: boolean },
) =>
  queryOptions({
    queryKey: helpscoutQueryKeys.all(workspaceAlias),
    queryFn: () => getHelpscoutInfo({ workspace_id: workspaceAlias }),
    placeholderData: null,
    ...options,
  });

/**
 * Helpscout mailbox 목록 조회 queryOptions
 */
export const helpscoutMailboxesQueryOptions = (
  workspaceAlias: string,
  options?: { enabled?: boolean },
) =>
  queryOptions({
    queryKey: helpscoutQueryKeys.mailboxes(workspaceAlias),
    queryFn: () => getHelpscoutMailboxes({ workspace_id: workspaceAlias }),
    placeholderData: [],
    ...options,
  });
